module.exports = __webpack_public_path__ + "assets/img/yzzx_m_anrukaixuan.d8932ead.png";